import { useEffect, useMemo, useState } from 'react';

import { useValidation } from './useValidation';

export const useValidationParts = ({ error, parts, schema }) => {
  const values = Object.values(parts);

  const [controlled, setControlled] = useState(false);
  const [errors, setErrors] = useState({});

  const { validateSync } = useValidation({ schema, values: parts });

  const validateResult = useMemo(() => {
    return validateSync();
  }, [validateSync, ...values]);

  useEffect(
    () => {
      if (!controlled) {
        return;
      }

      /**
       * При вводе данных ошибка исчезает.
       * Если данные неверны, ошибка не появляется до следующего нажатия на кнопку "Продолжить".
       * */
      setErrors((errors) => {
        return Object.entries(errors).reduce((acc, [key, previous]) => {
          const current = validateResult[key];

          if (previous) {
            acc[key] = current;
          }

          return acc;
        }, {});
      });
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [controlled, ...values]
  );

  /**
   * Хук взаимодействует с полями, представленными в интерфейсе как несколько элементов.
   * Когда пользователь вводит данные, ошибка сбрасывается для всего поля, а не для отдельных его частей.
   * Чтобы обработать ошибки для каждой части поля, нужно определить момент появления общей ошибки.
   * */
  useEffect(
    () => {
      if (!error) {
        return;
      }

      setControlled(true);
      setErrors(validateResult);
    },
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [error]
  );

  return { errors };
};
